import gql from 'graphql-tag'


export const STEP = gql`
    query events {
        events {
            id
            title
            status
            logo
            address
            address2
            addressCity
            addressState
            addressZip
            addressLat
            addressLng
            website
            twitter
            instagram
            facebook
            onDate
            description
            timezone
            reviews {
                id
                title
                description
                details
                rating
                user {
                    firstName
                    lastName
                }
            }
        }
    }
`

export const STEPS = gql`
 query steps {
    steps {
        id
    }
 }
`

export const CREATE_STEP = gql`
 mutation createStep($data: StepInput) {
    createStep(data: $data) {
        id
    }
 }
`

export const UPDATE_STEP = gql`
 mutation updateStep($data: StepInput) {
    updateStep(data: $data) {
        id
    }
 }
`

export const DELETE_STEP = gql`
 mutation deleteStep($id: String!) {
    deleteStep(id: $id)
 }
`